<template>
		<!-- Sidebar -->
		<div class="sidebar" id="sidebar">
			<!-- Logo -->
			<div class="sidebar-logo active">
        <router-link to="/" class="logo logo-normal">
          <img src="/assets/img/otobonik-logo.png" alt="Img">
        </router-link>
        <router-link to="/" class="logo logo-white">
          <img src="/assets/img/otobonik-logo.png" alt="Img">
        </router-link>
        <router-link to="/" class="logo-small">
          <img src="/assets/img/otobonik-small.png" alt="Img">
        </router-link>
				<a id="toggle_btn" >
					<i class="ti ti-chevrons-left" style="font-size:16px;"></i>
				</a>
			</div>
			<!-- /Logo -->

			<div class="modern-profile p-3 pb-0">
				<div class="text-center rounded bg-light p-3 mb-4 user-profile">
					<div class="avatar avatar-lg online mb-3">
						<img src="/assets/img/customer/customer15.jpg" alt="Img" class="img-fluid rounded-circle">
					</div>
					<h6 class="fs-14 fw-bold mb-1">Adrian Herman</h6>
					<p class="fs-12 mb-0">System Admin</p>
				</div>
				<div class="sidebar-nav mb-3">
					<ul class="nav nav-tabs nav-tabs-solid nav-tabs-rounded nav-justified bg-transparent" role="tablist">
						<li class="nav-item"><a class="nav-link active border-0" href="#">Menu</a></li>
						<li class="nav-item"><a class="nav-link border-0" href="chat.html">Chats</a></li>
						<li class="nav-item"><a class="nav-link border-0" href="email.html">Inbox</a></li>
					</ul>
				</div>
			</div>
			<div class="sidebar-header p-3 pb-0 pt-2">
				<div class="text-center rounded bg-light p-2 mb-4 sidebar-profile d-flex align-items-center">
					<div class="avatar avatar-md onlin">
						<img src="/assets/img/customer/customer15.jpg" alt="Img" class="img-fluid rounded-circle">
					</div>
					<div class="text-start sidebar-profile-info ms-2">
						<h6 class="fs-14 fw-bold mb-1">Adrian Herman</h6>
						<p class="fs-12">System Admin</p>
					</div>
				</div>
				<div class="d-flex align-items-center justify-content-between menu-item mb-3">
					<div>
						<a href="index.html" class="btn btn-sm btn-icon bg-light">
							<i class="ti ti-layout-grid-remove"></i>
						</a>
					</div>
					<div>
						<a href="chat.html" class="btn btn-sm btn-icon bg-light">
							<i class="ti ti-brand-hipchat"></i>
						</a>
					</div>
					<div>
						<a href="email.html" class="btn btn-sm btn-icon bg-light position-relative">
							<i class="ti ti-message"></i>
						</a>
					</div>
					<div class="notification-item">
						<a href="activities.html" class="btn btn-sm btn-icon bg-light position-relative">
							<i class="ti ti-bell"></i>
							<span class="notification-status-dot"></span>
						</a>
					</div>
					<div class="me-0">
						<a href="general-settings.html" class="btn btn-sm btn-icon bg-light">
							<i class="ti ti-settings"></i>
						</a>
					</div>
				</div>
			</div>

      <div class="sidebar-inner slimscroll">
        <div id="sidebar-menu" class="sidebar-menu">
          <ul>
            <!-- Dashboard -->
            <li>
              <h6 class="submenu-hdr">Main</h6>
              <router-link to="/" active-class="active">
                <i class="ti ti-layout-dashboard me-1"></i>
                <span>Dashboard</span>
              </router-link>
            </li>

            <!-- Inventory Menu -->
            <li v-if="canViewInventoryMenu" class="submenu">
              <a href="#" @click.prevent="toggleMenu('inventory')"
                 :class="{ 'subdrop active': isOpen('inventory') }">
                <i class="ti ti-packages fs-16 me-2"></i>
                <span>Inventory</span>
                <span class="menu-arrow"></span>
              </a>
              <ul :style="{ display: isOpen('inventory') ? 'block' : 'none' }">
                <li v-if="can('inventory.item', 'R')">
                  <router-link to="/items" active-class="active" >
                    <i class="ti ti-package me-1"></i>Item
                  </router-link>
                </li>
                <li v-if="can('inventory.category', 'R')">
                  <router-link to="/category" active-class="active" >
                    <i class="ti ti-folders me-1"></i>Category
                  </router-link>
                </li>
                <li v-if="can('inventory.sub_category', 'R')">
                  <router-link to="/sub/category" active-class="active" >
                    <i class="ti ti-folders me-1"></i>Sub Category
                  </router-link>
                </li>
                <li v-if="canViewUnitsMenu" class="submenu">
                  <a href="#" @click.prevent="toggleSubMenu('units')"
                    :class="{ 'subdrop active': isSubOpen('units') }">
                    <i class="ti ti-report fs-16 me-2"></i>
                    <span>Units</span>
                    <span class="menu-arrow"></span>
                  </a>
                  <ul :style="{ display: isSubOpen('units') ? 'block' : 'none' }">
                    <li v-if="can('inventory.item_color', 'R')">
                      <router-link to="/item/color" active-class="active" >
                        <i class="ti ti-palette me-1"></i>Color
                      </router-link>
                    </li>
                    <li v-if="can('inventory.item_size', 'R')">
                      <router-link to="/item/size" active-class="active" >
                        <i class="ti ti-arrows-maximize me-1"></i>Size
                      </router-link>
                    </li>
                    <li v-if="can('inventory.measurement_units', 'R')">
                      <router-link to="/measurement/unit" active-class="active" >
                        <i class="ti ti-ruler-measure me-1"></i>Measurement Units
                      </router-link>
                    </li>
                  </ul>
                </li>
                <li v-if="can('inventory.configuration', 'R')">
                  <router-link to="/inventory/store" active-class="active" >
                    <i class="ti ti-building-store me-1"></i>Store
                  </router-link>
                </li>
                <li v-if="can('inventory.warehouse', 'R')">
                  <router-link to="/inventory/warehouse" active-class="active" >
                    <i class="ti ti-building-warehouse me-1"></i>Warehouse
                  </router-link>
                </li>
                <li v-if="can('inventory.barcode_generator', 'R')">
                  <router-link to="/print/barcodes" active-class="active">
                    <i class="ti ti-barcode me-1"></i>Barcode
                  </router-link>
                </li>
                <li v-if="can('inventory.damage_item', 'R')">
                  <router-link to="/damage/item" active-class="active" >
                    <i class="ti ti-alert-triangle me-1"></i>Damage Item
                  </router-link>
                </li>
                <li v-if="can('inventory.configuration', 'R')">
                  <router-link to="/vat/groups" active-class="active" >
                    <i class="ti ti-receipt-tax me-1"></i>Vat Groups
                  </router-link>
                </li>
                <li v-if="can('inventory.configuration', 'R')">
                  <router-link to="/setting/list" active-class="active" >
                    <i class="ti ti-settings me-1"></i>Configuration
                  </router-link>
                </li>
                <li v-if="can('inventory.configuration', 'R')">
                  <router-link to="/invoice/setting/list" active-class="active" >
                    <i class="ti ti-settings me-1"></i>Invoice Setting
                  </router-link>
                </li>
              </ul>
            </li>

            <!-- Sales Menu -->
            <li v-if="canViewSalesMenu" class="submenu">
              <a href="#" @click.prevent="toggleMenu('sales')"
                 :class="{ 'subdrop active': isOpen('sales') }">
                <i class="ti ti-shopping-cart fs-16 me-2"></i>
                <span>Sales</span>
                <span class="menu-arrow"></span>
              </a>
              <ul :style="{ display: isOpen('sales') ? 'block' : 'none' }">
                <li v-if="can('sales.pos', 'R')">
                  <router-link to="/pos" active-class="active" >
                    <i class="ti ti-device-laptop me-1"></i>POS
                  </router-link>
                </li>
                <li v-if="can('sales.sales_return', 'R')">
                  <router-link to="/sales/return/list" active-class="active" >
                    <i class="ti ti-arrow-back me-1"></i>Sales Return
                  </router-link>
                </li>
                <li v-if="can('sales.customer_due_receive', 'R')">
                  <router-link to="/customer/due/receive/list" active-class="active" >
                    <i class="ti ti-cash me-1"></i>Customer Due
                  </router-link>
                </li>
                <li v-if="can('sales.customer', 'R')">
                  <router-link to="/customers/list" active-class="active" >
                    <i class="ti ti-users me-1"></i>Customer
                  </router-link>
                </li>
                <li v-if="can('sales.invoice_print', 'R')">
                  <router-link to="/print/invoice" active-class="active">
                    <i class="ti ti-receipt me-1"></i>Invoice Printing
                  </router-link>
                </li>
              </ul>
            </li>

            <!-- Purchases Menu -->
            <li v-if="canViewPurchaseMenu" class="submenu">
              <a href="#" @click.prevent="toggleMenu('purchases')"
                 :class="{ 'subdrop active': isOpen('purchases') }">
                <i class="ti ti-shopping-bag fs-16 me-2"></i>
                <span>Purchases</span>
                <span class="menu-arrow"></span>
              </a>
              <ul :style="{ display: isOpen('purchases') ? 'block' : 'none' }">
                <li v-if="can('purchase.purchase_entry', 'R')">
                  <router-link to="/batches" active-class="active" >
                    <i class="ti ti-shopping-cart-plus me-1"></i>Purchase Entry
                  </router-link>
                </li>
                <li v-if="can('purchase.purchase_return', 'R')">
                  <router-link to="/purchase/return/list" active-class="active" >
                    <i class="ti ti-arrow-back me-1"></i>Purchase Return
                  </router-link>
                </li>
                <li v-if="can('purchase.supplier_due_payment', 'R')">
                  <router-link to="/supplier/due/list" active-class="active" >
                    <i class="ti ti-credit-card-pay me-1"></i>Due Payment
                  </router-link>
                </li>
                <li v-if="can('purchase.supplier', 'R')">
                  <router-link to="/inventory/supplier" active-class="active" >
                    <i class="ti ti-users me-1"></i>Supplier
                  </router-link>
                </li>
              </ul>
            </li>

            <!-- User Management Menu -->
            <li v-if="canViewUserMenu" class="submenu">
              <a href="#" @click.prevent="toggleMenu('user')"
                 :class="{ 'subdrop active': isOpen('user') }">
                <i class="ti ti-users fs-16 me-2"></i>
                <span>User Management</span>
                <span class="menu-arrow"></span>
              </a>
              <ul :style="{ display: isOpen('user') ? 'block' : 'none' }">
                <li v-if="can('rbac.user', 'R')">
                  <router-link to="/users/" active-class="active" >
                    <i class="ti ti-receipt me-1"></i>Users
                  </router-link>
                </li>
                <li v-if="can('rbac.role', 'R')">
                  <router-link to="/roles/" active-class="active" >
                    <i class="ti ti-receipt me-1"></i>Roles
                  </router-link>
                </li>
              </ul>
            </li>

            <!-- Reports Menu -->
            <li v-if="canViewReports">
              <router-link
                to="/item/return/report"
                class="menu-link"
                :class="{ active: $route.path === '/item/return/report' }"
                active-class="active"
              >
                <i class="ti ti-report fs-16 me-2"></i>
                <span>Reports</span>
              </router-link>
            </li>

            <!-- Finance & Accounts Menu -->
            <li v-if="can('inventory.configuration', 'R')" class="submenu">
              <a href="#" @click.prevent="toggleMenu('finance')"
                 :class="{ 'subdrop active': isOpen('finance') }">
                <i class="ti ti-currency-dollar fs-16 me-2"></i>
                <span>Finance & Accounts</span>
                <span class="menu-arrow"></span>
              </a>
              <ul :style="{ display: isOpen('finance') ? 'block' : 'none' }">
<!--                <li><router-link active-class="active" :to="{ name: 'IncomeHeadList' }">Income Head List</router-link></li>-->
<!--                <li><router-link active-class="active" :to="{ name: 'ExpenseHeadList' }">Expense Head List</router-link></li>-->
<!--                <li><router-link active-class="active" :to="{ name: 'SupplierHeadList' }">Supplier Due Head List</router-link></li>-->
                <li v-if="can('inventory.configuration', 'R')">
                  <router-link active-class="active" :to="{ name: 'BankAccountHeadList' }">Bank Account List</router-link>
                </li>
<!--                <li><router-link active-class="active" :to="{ name: 'CustomerHeadList' }">Customer Due Head List</router-link></li>-->
              </ul>
            </li>
          </ul>
        </div>
      </div>

      <div class="sidebar-footer">
          © 2026 <a href="https://entrancelogic.com/" target="_blank" rel="noopener">Entrance Logic Systems</a>
      </div>
    </div>
		<!-- /Sidebar -->
</template>

<script>
export default {
  name: "Sidebar",

  data() {
    return {
      openMenu: null,
      openSubMenu: null,
      permissions: JSON.parse(localStorage.getItem("permissions")) || {}
    };
  },

  computed: {
    canViewUnitsMenu() {
      return (
        this.can('inventory.item_color', 'R') ||
        this.can('inventory.item_size', 'R') ||
        this.can('inventory.measurement_units', 'R')
      )
    },

    canViewUserMenu() {
      return (
        this.can('rbac.user', 'R') ||
        this.can('rbac.role', 'R')
      )
    },

    canViewReports() {
      return (
        this.can('sales.report.sale_return', 'R') ||
        this.can('inventory.report.stock', 'R') ||
        this.can('purchase.report.batch', 'R') ||
        this.can('sales.report.sale', 'R') ||
        this.can('purchase.report.buy', 'R') ||
        this.can('inventory.report.low_stock', 'R') ||
        this.can('sales.report.customer_due', 'R') ||
        this.can('purchase.report.supplier_payment', 'R')
      );
    },

    canViewInventoryMenu() {
      return (
        this.can('inventory.item', 'R') ||
        this.can('inventory.category', 'R') ||
        this.can('inventory.sub_category', 'R') ||
        this.can('inventory.item_color', 'R') ||
        this.can('inventory.item_size', 'R') ||
        this.can('inventory.measurement_units', 'R') ||
        this.can('inventory.warehouse', 'R') ||
        this.can('inventory.barcode_generator', 'R') ||
        this.can('inventory.damage_item', 'R') ||
        this.can('inventory.configuration', 'R')
      );
    },

    canViewSalesMenu() {
      return (
        this.can('sales.pos', 'R') ||
        this.can('sales.sales_return', 'R') ||
        this.can('sales.customer_due_receive', 'R') ||
        this.can('sales.customer', 'R') ||
        this.can('sales.invoice_print', 'R')
      );
    },

    canViewPurchaseMenu() {
      return (
        this.can('purchase.purchase_entry', 'R') ||
        this.can('purchase.purchase_return', 'R') ||
        this.can('purchase.supplier_due_payment', 'R') ||
        this.can('purchase.supplier_due_payment', 'R')
      );
    },

  },

  methods: {
    toggleMenu(menuKey) {
      this.openMenu = this.openMenu === menuKey ? null : menuKey;
    },

    toggleSubMenu(subKey) {
      this.openSubMenu = this.openSubMenu === subKey ? null : subKey;
    },

    isOpen(menuKey) {
      return this.openMenu === menuKey;
    },

    isSubOpen(subKey) {
      return this.openSubMenu === subKey;
    },

    can(code, requiredLevel) {
      const perms = JSON.parse(localStorage.getItem("permissions")) || {};
      const userLevel = perms[code] || 'N';

      for (const char of requiredLevel) {
        if (!userLevel.includes(char)) {
          return false;
        }
      }
      return true;
    },
  }
};
</script>
